export const KK = {
    translations: {
        notifications: 'Хабарландырулар',
        markAllAsRead: 'барлығын оқылған деп белгілеңіз',
        poweredBy: 'задвижвани от',
        settings: 'көмегімен',
        noNewNotification: 'Мұнда әлі көретін жаңа ештеңе жоқМұнда әлі көретін жаңа ештеңе жоқ',
    },
    lang: 'kk',
};
//# sourceMappingURL=kk.js.map